/* app/js/src/components/common/simple-text-input/simple-text-input.component.scss */
.container input:focus {
  border: 1px solid #aee5ff !important;
  outline: none;
  transition: all 0.9s ease 0s !important;
}
/*# sourceMappingURL=simple-text-input.component.css.map */
